export const useShowLgbtElements = () => {
  const date = new Date();
  const month = date.getMonth(); // 0-11
  const year = date.getFullYear(); // 2021
  const day = date.getDate(); // 1-31
  const showTransFlag = month === 2 && year === 2023 && day >= 30 && day <= 31;
  const showLGBTFlag = month === 5 && year === 2025;
  const showLgbtElements = month === 5 && year === 2024;

  return { showTransFlag, showLGBTFlag, showLgbtElements };
};
